import { SearchType } from '@aibees/elephant/types';
import { notificationIconMap } from '@aibees/elephant/utils';
import { TableProps } from '@aibees/shared/components';
import { useNotify } from '@aibees/shared/hooks';
import { fNumber } from '@aibees/shared/utils';
import { random } from 'lodash-es';
import { SaveRecordAction } from '../types';
import { useSaveRecord } from '../use-save-record';

export function useEnrichPersonSaveRecord(
  action: SaveRecordAction | SaveRecordAction[],
  onClose: () => void,
  table?: TableProps,
  enrichable?: number
) {
  const { mutate, isLoading } = useSaveRecord(SearchType.People);
  const notify = useNotify();

  const handleEnrich = () => {
    const ids = table?.selection.included;

    if (ids) {
      notify.progress(
        'Enriching is in progress',
        `You have started the enriching process for <b>${fNumber(
          enrichable || ids.length
        )}</b>. Enriching many records may take time. We'll notify you when it's ready.`,
        random(1, 100),
        {
          icon: notificationIconMap.Enrich,
        }
      );
      // The dialog closes before the request resolves — running and completion
      // feedback belongs to the top product notification, not to the modal.
      onClose();
      // `mutate`, not `mutateAsync`: nothing here awaits the result, and an
      // unawaited mutateAsync rejection escapes as an unhandled promise. The
      // failure path is already covered — useSaveRecord's own onError closes the
      // progress snackbar and surfaces the backend message.
      mutate(
        {
          ids,
          kind: 'ADD',
          actions: Array.isArray(action) ? action : [action],
        },
        {
          onSuccess() {
            notify.closeSnackbar();
            notify.complete(
              'Enriching is complete',
              `The enriching process for <b>${fNumber(
                enrichable || ids.length
              )}</b> has been successfully completed.`,
              random(1, 101),
              {
                icon: notificationIconMap.Enrich,
              }
            );
          },
        }
      );
    }
  };
  return { handleEnrich, isLoading };
}
